var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "612px",
    height: "552px",
    viewBox: "0 0 612 552",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "menuIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menuIcon",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M581.4,490.199 L30.6,490.199 C13.709,490.199 0,503.908 0,520.799 C0,537.691 13.709,551.4 30.6,551.4 L581.4,551.4 C598.291,551.4 612,537.691 612,520.798 C612,503.908 598.291,490.199 581.4,490.199 Z M30.6,61.799 L581.4,61.799 C598.291,61.799 612,48.091 612,31.199 C612,14.307 598.291,0.599 581.4,0.599 L30.6,0.599 C13.709,0.6 0,14.308 0,31.2 C0,48.091 13.709,61.799 30.6,61.799 Z M581.4,245.399 L30.6,245.399 C13.709,245.399 0,259.108 0,276 C0,292.892 13.709,306.6 30.6,306.6 L581.4,306.6 C598.291,306.6 612,292.891 612,276 C612,259.109 598.291,245.399 581.4,245.399 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menuIcon.527db5dfeb127ac0342bda0848809b98.svg";
export { ForwardRef as ReactComponent };